import { TableHead, TableRow, TableCell, Box, Typography } from '@mui/material';
import { TooltipCheckboxCell } from '../../tooltip_checkbox_cell';
import { PageNavigateCheckboxCell } from '../../page_navigate_checkbox_cell';
import { TypographyCheckSell, HeaderTypographyNomalBold } from '../../../style/typography';
import { CheckboxCell, ArrowCell } from '../../../style/tablecell';

export const OptionalTableHeader = ({ uuid, resetRef, notReportRef, nameRef, lefts }) => {
  return (
    <TableHead>
      <TableRow>
        {/* 固定列 */}
        <TableCell
          ref={resetRef}
          sx={{
            width: 65,
            minWidth: 65,
            fontWeight: 'bold',
            position: 'sticky',
            top: 0,
            left: lefts.reset,
            zIndex: 1000,
            backgroundColor: 'background.paper',
            borderBottom: '1px solid rgba(224,224,224,1)'
          }}
        >
          <HeaderTypographyNomalBold>リセット</HeaderTypographyNomalBold>
        </TableCell>

        <TableCell
          ref={notReportRef}
          align="center"
          sx={{
            width: 80,
            minWidth: 80,
            fontWeight: 'bold',
            position: 'sticky',
            top: 0,
            left: lefts.notReport,
            zIndex: 1000,
            backgroundColor: 'background.paper',
            borderBottom: '1px solid rgba(224,224,224,1)'
          }}
        >
          <HeaderTypographyNomalBold>報告対象外</HeaderTypographyNomalBold>
        </TableCell>

        <TableCell
          ref={nameRef}
          sx={{
            minWidth: 120,
            fontWeight: 'bold',
            position: 'sticky',
            top: 0,
            left: lefts.name,
            zIndex: 1000,
            backgroundColor: 'background.paper',
            borderBottom: '1px solid rgba(224,224,224,1)',
            borderRight: '1px solid rgba(224,224,224,1)'
          }}
        >
          <HeaderTypographyNomalBold>発電所名</HeaderTypographyNomalBold>
        </TableCell>

        {/* 横スクロール可能列 */}
        <TableCell>
          <HeaderTypographyNomalBold>地震発生日時</HeaderTypographyNomalBold>
        </TableCell>

        <TooltipCheckboxCell
          cellLabel="各発電所運転状況確認"
          tooltipContent={<>{'ヘッドタンク水位に変わりはないか'}</>}
        />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <TooltipCheckboxCell
          cellLabel="取水停止・水路抜水・運転継続の対象発電所を決定"
          tooltipContent={<>{'震度5弱以上を観測した発電所又は保守担当箇所の長及びダム水路保安監理担当と協議し決定する'}</>}
        />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>取水停止・水路抜水・運転継続の対象発電所を電気グループへ共有</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <TooltipCheckboxCell
          cellLabel="灌漑利水者へ連絡"
          tooltipContent={<>{'水路抜水に当たり、予防停止操作手順書ファイルにある予防停止関係箇所連絡一覧表を確認し関係者全員に連絡'}</>}
        />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <TooltipCheckboxCell
          cellLabel={
            <span style={{ whiteSpace: 'pre-line', display: 'inline-block' }}>
              {`取水停止(遠隔操作有)の実施及び総制への連絡\n※遠隔可の門扉は同時並行で対応\n※ニシコーへは代表者1名大分支店へ来てもらうように依頼`}
            </span>
          }
          tooltipContent={
            <span style={{ whiteSpace: 'pre-line', display: 'inline-block' }}>
              {'震度5弱以上を観測した発電所又は保守担当箇所の長及びダム水路保安監理担当が判断した発電所は取水停止(遠隔操作有)を実施してください。（協力会社及び二シコーへ指示）\nまた、水路残留水を早期に抜水するため発電機は自動停止（37動作又は水槽水位低下2段）まで運転を継続して実施するように総制へ依頼してください。'}
            </span>
          }
        />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <PageNavigateCheckboxCell cellLabel="取水停止連絡" subLabel={'※余震に注意すること'} />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>取水停止完了</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <TooltipCheckboxCell
          cellLabel="ニシコーとの情報共有チャネルで都度更新"
          tooltipContent={<>{'取水停止や今後の門扉操作の状況は、チームスのニシコーとの情報共有チャネルエクセルシートで都度更新'}</>}
        />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>水力中給に情報共有</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <TooltipCheckboxCell
          cellLabel="安全確認後(余水路の異常有無、入巡者の有無)水路抜水"
          tooltipContent={
            <span style={{ whiteSpace: 'pre-line', display: 'inline-block' }}>
              {'震度5弱以上を観測した発電所又は保守担当箇所の長及びダム水路保安管理担当が判断した発電所は、取水停止が完了した発電所から安全確認後(余水路の異常有無、入巡者の有無)水路抜水を実施してください。\n（協力会社及び二シコーへ指示）'}
            </span>
          }
        />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <PageNavigateCheckboxCell cellLabel="水路抜水連絡" subLabel={'※余震に注意すること'} />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>水路抜水完了</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>ニシコーとの情報共有チャネルで都度更新</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>水路内部点検実施箇所決定</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>水路内部点検者の決定</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <PageNavigateCheckboxCell cellLabel="臨時点検の要請" uuid={uuid} subLabel={'※余震に注意すること'} />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>臨時点検完了</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <TooltipCheckboxCell
          cellLabel="様式1の更新"
          tooltipContent={<>{'1次点検完了後速やかにチームスのチーム「水力運営グループ」にアップした様式１の資料を都度、更新してください。更新後、水力運営グループに連絡してください。'}</>}
          subLabel={'※点検が３時間を超える場合は途中経過を報告'}
        />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <TooltipCheckboxCell
          cellLabel={<span style={{ whiteSpace: 'pre-line', display: 'inline-block' }}>{`臨時点検異常あり`}</span>}
          tooltipContent={<>{'臨時点検で異常がある場合は、「管理職報告〜灌漑利水者への連絡」までを実施して下さい。'}</>}
        />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>管理職報告</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <TooltipCheckboxCell
          cellLabel={
            <span style={{ whiteSpace: 'pre-line', display: 'inline-block' }}>
              {
                `
                水路抜水の対象発電所を決定
                灌漑利水者へ連絡
                `
              }
            </span>
          }
          tooltipContent={<>{'協力会社及びニシコーへ緊急取水停止及び導水路抜水指示'}</>}
        />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <PageNavigateCheckboxCell cellLabel="水路抜水要請" subLabel={'※余震に注意すること'} />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>水路抜水完了</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <TypographyCheckSell>内部点検実施</TypographyCheckSell>
            <Typography
              sx={{
                color: 'red',
                fontSize: '0.7rem',
                fontWeight: 'bold',
                lineHeight: 1.2,
                marginTop: '2px'
              }}
            >
              ※余震に注意すること
            </Typography>
          </Box>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>内部点検完了</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <TooltipCheckboxCell
          cellLabel="様式1の更新"
          tooltipContent={
            <span style={{ whiteSpace: 'pre-line', display: 'inline-block' }}>
              {'1次点検完了後速やかにチームスのチーム「水力運営グループ」にアップした様式１の資料を都度、更新してください。\n更新後、水力運営グループに連絡してください。'}
            </span>
          }
        />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <TooltipCheckboxCell
          cellLabel="発電再開箇所決定"
          tooltipContent={<>{'発電再開箇所を保守担当箇所の長及びダム水路保安監理担当と協議して決定してください。'}</>}
        />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <TooltipCheckboxCell
          cellLabel="灌漑利水者へ連絡"
          tooltipContent={<>{'取水再開及び水路充水に当たり、予防停止操作手順書ファイルにある予防停止関係箇所連絡一覧表を確認し関係者全員に充水完了目途（日時）の連絡をしてください。\n※充水できない異常が確認された場合、関係者へ連絡する前に保守担当箇所の長へ相談'}</>}
        />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>水力中給に取水再開及び水路充水の連絡・共有</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <PageNavigateCheckboxCell cellLabel="水路充水要請" subLabel={'※余震に注意すること'} />

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>充水完了</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>グループ長報告</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>発電再開</TypographyCheckSell>
        </CheckboxCell>

        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <TooltipCheckboxCell
          cellLabel="灌漑利水者へ連絡"
          tooltipContent={<>{'取水再開及び水路充水に当たり、予防停止操作手順書ファイルにある予防停止関係箇所連絡一覧表を確認し関係者全員に充水完了目途（日時）の連絡をしてください。'}</>}
        />
        <ArrowCell><HeaderTypographyNomalBold>→</HeaderTypographyNomalBold></ArrowCell>

        <CheckboxCell>
          <TypographyCheckSell>完了</TypographyCheckSell>
        </CheckboxCell>
      </TableRow>
    </TableHead>
  );
};